module.exports = __webpack_public_path__ + "static/media/ClearSkies.c3d9bdd7.svg";